import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLightningReportTypeRules } from '../../../../../data/analyze/reportTypeRules.ts'
import { CoverageZonesLayer } from '../../CoverageZonesLayer.tsx'
import { useLightningFormValues } from '../schema.tsx'

export const NldnBoundaryLayer = () => {
	const { t } = useTranslation()
	const [dataset] = useLightningFormValues(['dataset'])
	const nldnCoverage = useLightningReportTypeRules().coverageZones.NLDN?.geometry
	const geometries = useMemo(() => (nldnCoverage ? [nldnCoverage] : []), [nldnCoverage])

	return (
		dataset === 'NLDN' && <CoverageZonesLayer geometries={geometries} label={t(($) => $.reports.lightning.form.nldnReprocessedBoundary)} />
	)
}
